<!-- Sites -->
<template>
    <v-row no-gutters class="fill-height noprint">
        <!-- // * LEFT PANEL -->
        <v-col :cols="GET_panelLayout.leftPanel" >
            <v-row class="px-2 mt-2 pa-0" dense>
                <!-- // * DESCRIPTION (GENERIC) -->
                <v-col :cols="computedCols">
                    <v-row no-gutters class="">
                        <v-col class="px-2" cols="12" xs="6" sm="6" md="12">
                            <app-text category="content-title">{{ $t(`${langPath}.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                            <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.text`) }}</app-text>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * FILTERS (CUSTOM) -->
                <v-col :cols="computedCols" class="px-2">
                    <v-row dense>
                        <v-col cols="12" xs="12" sm="12" md="4" class="">
                            <v-text-field background-color="white" v-model="search" prepend-inner-icon="icons8-search" filled dense :label="$t(`filters.search`)" clearable hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.siteType" :items="siteTypes" item-text="text" item-value="value" filled dense clearable :label="$t(`filters.type`)" hide-details>
                                <template v-slot:item="data">{{ data.item.text }}</template>
								<template v-slot:selection="data">{{ data.item.text }}</template> 
                            </v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="d-flex align-center" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="sortBy" :items="filteredHeaders" item-text="text" item-value="value" filled clearable dense :label="$t(`filters.sortBy`)" hide-details>
                                <template v-slot:item="data">{{ $t(`fields.${data.item.text}`) }}</template>
                                <template v-slot:selection="data">{{ $t(`fields.${data.item.text}`) }}</template>
                            </v-select>
                            <v-btn icon class="ml-2" @click="filter.sortAsc = !filter.sortAsc"><v-icon :class="{ 'icons8-down-arrow': filter.sortAsc, 'icons8-up-arrow': !filter.sortAsc }" class="text-h5"></v-icon></v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * STATUS AND BUTTONS -->
                <v-col cols="12" class="pl-2 pr-0 d-flex align-center">
                        <!-- // * SHOW DELETED -->
                        <div class="d-flex" v-if="$vuetify.breakpoint.mdAndUp">
                            <v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon>
                            <v-switch @change="getTableData()" v-model="showDeleted" class="ml-1 purple--text" inset color="purple"></v-switch>
                        </div>
                        <v-spacer></v-spacer>
                        <!-- // * BUTTONS -->
                        <div><appbutton :label="$t(`buttons.add`)" icon="icons8-apartment" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" @click.native="openItem('', 'New', false)" /></div>
                        <div v-if="$vuetify.breakpoint.mdAndUp"><appbutton :label="$t(`buttons.columns`)" icon="icons8-select-column" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="2xlOnly" @click.native="columnsDialog = true" /></div>
                        <div v-if="$vuetify.breakpoint.mdAndUp"><appbutton :label="$t(`buttons.export`)" icon="icons8-export-csv" type="secondary" class="mr-1" iconclass="white--text" labelclass="white--text" showlabel="2xlOnly" @click.native="mix_exportDocuments(headersCSV,'Sites',formatExport)" /></div>
                        </v-col>
                <!-- // * TABLE -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.mdAndUp" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-data-table
                        :headers="filteredHeaders"
                        :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                        :items="computedTableData"
                        item-key="id"
                        class="elevation-0"
                        hide-default-header
                        :search="search">
                        <!-- // HEADERS (GENERIC) -->
                        <template v-slot:header="{ props }">
                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                {{ $t(`fields.${head.text}`) }}
                            </th>
                        </template>
                        <!-- // NAME (CUSTOM) -->
                        <template v-slot:[`item.siteName`]="{ item }">
                            <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="purple--text d-inline-block text-truncate" style="max-width: 200px;"><v-icon class="purple--text">icons8-trash</v-icon> {{ item.siteName}}</span>
                            <span v-else class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.siteName }}</span>
                        </template>
                        <!-- // SITE TYPE -->
                        <template v-slot:[`item.siteType`]="{ item }">
                            {{ lookupField('siteTypes', 'text', item.siteType)  }}
                        </template>

                        <!-- // ACTION -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn @click="openItem(item.id, 'View', false)" depressed class="black--text white">Open<v-icon>mdi-chevron-right</v-icon></v-btn>
                        </template>
                        <!-- // CREATED USER DATA -->
                        <template v-slot:[`item.createdUserData`]="{ item }">
                            <div v-if="item.createdUserData && item.createdUserData.userName" @click="MIX_popupUser(item.createdUserData.userId)" class="pointer noselect">
                                <v-icon>icons8-identification-documents</v-icon>
                                {{ item.createdUserData.userName }}
                            </div>
                        </template>
                        <!-- // MODIFIED USER DATA -->
                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                            <div v-if="item.modifiedUserData && item.modifiedUserData.userName" @click="MIX_popupUser(item.modifiedUserData.userId)" class="pointer noselect">
                                <v-icon>icons8-identification-documents</v-icon>
                                {{ item.modifiedUserData.userName }}
                            </div>
                        </template>
                        <!-- // DELETE USER DATA -->
                        <template v-slot:[`item.deleteUserData`]="{ item }">
                            <div v-if="item.deleteUserData && item.deleteUserData.userName" @click="MIX_popupUser(item.deleteUserData.userId)" class="pointer noselect">
                                <v-icon>icons8-identification-documents</v-icon>
                                {{ item.deleteUserData.userName }}
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
                <!-- // * MOBILE CARDS / Instead of Table -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.smAndDown" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-row no-gutters>
                        <v-col cols="12" xs="12" class="my-1 pa-1 white tablecard" v-for="item in computedTableData" :key="item.id" @click="openItem(item.id, 'View', false)">
                            <v-row class="d-flex align-center justify-center pa-3 fill-height" no-gutters >
                                <v-col cols="9" class="d-flex flex-column">
                                    <div style="margin: 0px !important; line-height: 20px !important;" class="noselect"><span class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.siteName }}</span></div>
                                    <div style="" class="font-weight-bold caption grey--text text--darken-1 noselect">{{ item.siteType }}</div>
                                </v-col>
                                <v-col cols="3" class="text-right"><v-btn @click="openItem(item.id, 'View', false)" depressed class="black--text white">Open<v-icon>mdi-chevron-right</v-icon></v-btn></v-col>
                            </v-row>
                         </v-col>
                    </v-row>
                </v-col>
                <!-- // * COPYRIGHT -->
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-0 copyright">
                    <appcopyright  />
                </v-col>
            </v-row>
        </v-col>
        <!-- // * RIGHT PANEL -->
        <!-- // * DYNAMIC COMPONENT PANEL -->
        <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__fadeIn animated__faster"
            leave-active-class="animate__animated animate__fadeOut animated__faster"
            mode="out-in">
            <rightpanel></rightpanel>
             <!-- <component :is="dynamicComponent" :key="dynamicComponentKey"></component>      -->
        </transition>
        <!-- // * DYNAMIC COMPONENT DIALOG -->
        <v-dialog v-model="columnsDialog" scrollable max-width="300px">
            <v-card>
                <v-card-title>{{$t('miscHeadings.showHideColumns')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px;">
                    <v-list>
                        <v-list-item v-for="(header, index) in columnHeaders" :key="index">
                          <v-list-item-title><v-checkbox color="grey darken-1" hide-details v-model="headers[index].hidden" :false-value="true" :true-value="false" :label="$t(`fields.${header.text}`)"></v-checkbox></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer />
                    <v-btn color="primary" text @click="columnsDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'; // Map Actions / Getters
    export default {
        // * DATA
        data: () => ({
            // * DEFAULT DATA
            collection: 'sites',
            collectionItem: 'site',
            collectionItem: 'site',
            collectionItemTitle: 'Site',
            title: 'Site',
            langPath: 'sites',
            columnsDialog: false,
            search: '', // Table Search
            sortBy: 'siteName', // Default Table Sort By
            // * CUSTOM DATA
            filter: {
                // Default Filters
                sortAsc: true,
                siteType:''
            },
            tableData: [], // Table Data
            headers: [ // Table Headers
                // hidden shows the initial value of the column - hidden or visible
                // hides determines if you want to hide the column on screen resize
                { text: 'id', value: 'id', sortable: false, align: 'left', hidden: true, hide: true },
                { text: 'name',  value: 'siteName', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'type', value: 'siteType', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'telephone', value: 'siteTelephone', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'addressLine1', value: 'siteAddressLine1', align: 'left', sortable: false, hidden: true, hide: true },
                // { text: 'addressLine2', value: 'siteAddressLine2', align: 'left', sortable: false, hidden: true, hide: true },
                // { text: 'addressLine3', value: 'siteAddressLine3', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'town', value: 'siteTown', align: 'left', sortable: false, hidden: false, hide: true },
                { text: 'county', value: 'siteCounty', align: 'left', sortable: false, hidden: false, hide: true },
                { text: 'postcode', value: 'sitePostcode', align: 'left', sortable: false, hidden: false, hide: true },
                { text: 'created', value: 'createdDateTime', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'createdUserData', value: 'createdUserData', align: 'left', sortable: false, hidden: false, hide: true },
                { text: 'modified', value: 'modifiedDateTime', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'modifiedUserData', value: 'modifiedUserData', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'actions', value: 'actions', align: 'right', sortable: false, sortable: false, hidden: false,  hide: false },
            ],
            headersCSV: {
                id: 'ID',
                siteName: 'Name',
                siteType: 'Type',
                siteTelephone: 'Telephone',
                siteAddressLine1: 'Address',
                siteTown: 'Town',
                siteCounty: 'County',
                sitePostcode: 'Postcode',
                createdDateTime: 'Created Date and Time',
                createdUserData: 'Created By',
                modifiedDateTime: 'Modified Date and Time',
                modifiedUserData: 'Modified By',
            },
            // EXPORT
            exportData: [],

            // * LOCATIONS RELATED
            showDeletedLocations: false,


            // * COMMENTS RELATED
            commentsTableData: [], // populated from firestore on show comments
            commentsHeaders: [
                { text: 'private',  value: 'private', align: 'center', sortable: false, hidden: false, hide: false },
                { text: 'id', value: 'id', align: 'start',  sortable: false, hidden: true, hide: false },
                { text: 'comment', value: 'comment', align: 'start', sortable: false, hidden: false, hide: false, },
                { text: 'docLink', value: 'docLink', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'createdUserData', value: 'createdUserData', align: 'start', sortable: false, hidden: false, hide: true },
                { text: 'created', value: 'createdDateTime', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'modifiedUserData', value: 'modifiedUserData', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'modified', value: 'modifiedDateTime', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'delete',   value: 'delete',  align: 'start',  sortable: false, hidden: true, hide: false },
                { text: 'deleteUserData', value: 'deleteUserData', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'actions', value: 'actions', align: 'center', sortable: false, hidden: false, hide: false, width: '100px' },
            ],
            showDeletedComments: false, // Show Deleted Comments
            showIDComments: false,



            // LOOKUPS
            siteTypes: [],
            // DELETED
            showDeleted: false,
            filteredHeaders: []

        }),
        // * COMPUTED
        computed: {
            // Map Getters
            ...mapGetters({
                GET_panelLayout: 'GET_panelLayout',
                GET_currentUser: 'GET_currentUser',
                GET_currentUserData: 'GET_currentUserData',
                GET_lookupValues: 'GET_lookupValues',
                GET_help: 'GET_help'
            }),
            formatExport() {
                this.exportData = JSON.parse(JSON.stringify(this.computedTableData))
                return this.exportData
            },
            // Computed Table Headers
            // computedHeaders() {
            //     var t = this;
            //     var headers = this.headers;
            //     // headers.forEach(function(header) {
            //     //     header.text = t.$t(`fields.${header.text}`)
            //     // })
            //     return (this.$filter(headers, {
            //         hidden: false, // filter headers based on initial hidden value
            //     }));
            // },
            // Remove actions from Selectable Column Headers
            columnHeaders() {
                var t = this;
                var headers = t.headers;
                return (headers.filter((header) => {
                    return header.value !== 'actions'
                }));
            },            
            // Computed Cols
            computedCols() {
                var cols
                var leftPanel = this.GET_panelLayout.leftPanel
                switch (true) {
                    case (leftPanel === 12): cols = 6; break
                    case (leftPanel === 6): cols = 12; break;
                    default: cols = 12;
                }
                if (this.$vuetify.breakpoint.smAndDown) { cols = 12 }
                return cols
            },

            // Computed Table Data - for filtering and sorting
            computedTableData() {
                var t = this;
                var tableData = this.tableData
                // Filter by Site
                // if ((this.filter.site !== '') && (this.filter.site !== undefined) && (this.filter.site !== null)) {
                //     tableData = tableData.filter(function(item) {
                //         console.log('id = ' + item.site.siteId)
                //         console.log('filter id = ' + t.filter.site.id)
                //         return item.site.siteId === t.filter.site.id;
                //     })
                // }
                // // Filter by Contractor
                // if ((this.filter.contractor !== '') && (this.filter.contractor !== undefined) && (this.filter.contractor !== null)) {
                //     tableData = tableData.filter(function(item) {
                //         return item.contractor.id === t.filter.contractor.id;
                //     })
                // }
                // Filter by Type
                if ((t.filter.siteType !== '') && (t.filter.siteType !== undefined) && (t.filter.siteType !== null)) {
                    tableData = tableData.filter(function(item) {
                        return t.filter.siteType === item.siteType;
                    });
                }
                if (t.search !== '' && t.$vuetify.breakpoint.smAndDown) {
                    tableData = tableData.filter(function(item) {
                        var itemName = item.siteName.toUpperCase();
                        var search = t.search.toUpperCase();
                        return itemName.includes(search)
                    });
                }
                var tableDataList = tableData.map(e => {
                    return {
                        id: e.id,
                        siteName: e.siteName,
                        siteType: e.siteType,
                        siteTelephone: e.siteTelephone,
                        siteAddressLine1: e.siteAddressLine1,
                        siteTown: e.siteTown,
                        siteCounty: e.siteCounty,
                        sitePostcode: e.sitePostcode,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
                // Sort the Table by the Field in the Sort By Filter
                var sortResults = this.$sortBy(tableDataList, t.sortBy)
                if (!t.filter.sortAsc) {sortResults.reverse()}
                return (sortResults);
            },
            // Computed Comments Headers
            computedCommentsHeaders() {
                var t = this;
                var headers = t.commentsHeaders;
                var newHeaders = []
                for (var i = 0; i < headers.length; i++) {
                    var header = headers[i]
                    if (header.hidden) {
                        switch (true) {
                            // Add in Cases that need to be manually controlled
                            case (header.text === 'id'):
                                if (t.showIDComments) { newHeaders.push(header) } // remove if false
                                break;
                            case (header.text === 'deleteUserData'):
                                if (t.showDeletedComments) { newHeaders.push(header) } // remove if false
                                break;
                            default:
                                // do nothing

                        }
                    } else {
                        newHeaders.push(header)
                    }
                }
                return newHeaders
            },
            // Computed Commments Table Data
            computedCommentsTableData() {
                var t = this;
                var tableData = t.commentsTableData;
                var tableDataList = tableData.map(e => {
                    return {
                        private: e.private,
                        id: e.id,
                        comment: e.comment,
                        docLink: e.docLink,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
                return (tableDataList);
            }
        },
        // * WATCH
        watch: {
            GET_currentUser: {
                handler() {
                    this.getTableData();
                }, deep: true
            },
            GET_panelLayout: {
                handler() {
                    let t = this;
                    if (t.GET_panelLayout.rightPanel === 6) {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hide === false && header.hidden === false);
                        });
                    } else {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hidden === false);
                        }) 
                    }
                }, deep: true,
            },
            headers: {
                handler() {
                    let t = this;
                     t.filteredHeaders = t.headers.filter((header) => {
                         return (header.hidden === false)
                     });
                }, deep: true,
            }
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openSite', 'ACT_openSite': 'ACT_openSite'}),
            // this function hides columns on page resize
            // * DEFAULT METHODS
            // Update breadcrumbs
            updateBreadcrumbs() {
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `Sites`, path: `/sites`}) // Set the Main Path
                this.MIX_breadcrumbs(breadcrumbs);
            },
            openItem: async function(id, process, popup) {
                var t = this;
                var item = {}
                t.dynamicComponentKey++;
                item.process = process;
                item.popup = popup;
                if (item.process !== 'New') {
                    var itemResult = await t.MIX_readDocumentById(t.collection, id)
                    item.data = itemResult.data;
                } else {
                    item.data = null;
                }
                t.ACT_openItem(item); // Open Item
                if (t.$vuetify.breakpoint.lgAndDown) {
                    t.MIX_fsDialog(true, t.collectionItemTitle, t.collectionItem);
                    t.MIX_setPanelLayout(12, 0, false, '');
                } else {
                    t.MIX_setPanelLayout(6, 6, true, t.collectionItemTitle, t.collectionItem);
                    // // * HIDE HEADERS
                    // for (var i = 0; i < t.headers.length; i++) {
                    //     if (t.headers[i].hide === true) {
                    //         t.headers[i].hidden = true;
                    //     }
                    // }
                }
                return;
            },
            // GET NOTICES SNAPSHOT METHOD
            getTableData: async function () {
                var t = this;
                this.$firebase.db.collection(t.collection).onSnapshot(function(querySnapshot) {
                    t.tableData = [];
                    querySnapshot.forEach(function(doc) {
                        var document = doc.data()
                        document.id = doc.id;
                        if (!document.hasOwnProperty('delete')) {
                            t.tableData.push(document);
                        } else if (t.showDeleted) {
                            t.tableData.push(document);
                        } else {
                            // Do not Show Concern
                        }
                    });
                });
                return;
            },
            // LOOKUP FIELD (GENERIC)
            lookupField: function(lookup, field, value) {
                var t = this;
                var lookupResult = t.$find(t[lookup], { value: value })
                if (lookupResult !== undefined) {
                    return (lookupResult)[field];
                } else {
                    return ('NOTFOUND')
                }
            }
        },
        // * MOUNTED
        async mounted() {
            // GENERIC MOUNTED
            var t = this;
            t.MIX_setPanelLayout(12, 0, false, ''); // Hide Right Panel
            t.updateBreadcrumbs(); // Update Breadcrumbs in Title
            // INSERT CUSTOM WHERES HERE
            // t.customWhere.push ({ key: '', operator: '==', value: '' });
            t.getTableData(); // Get Table Data
            // LOOKUPS (CUSTOM)
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            t.siteTypes = await t.GET_lookupValues('SITETYPES');
            // GET SITES
            await t.MIX_sites(); // UPDATE SITES LIST IN STORE (id, siteName)
            t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY
            // * AUTO OPEN SITE IF PATH CONTAINS SITEID
            if ((window.location.pathname !== `/${t.collection}` && window.location.pathname !== `/${t.collection}/`)) {
                var urlPath = window.location.pathname.split('/');
                var id = urlPath[2];
                if (id === 'new') {
                    t.openItem('', 'New', false)
                } else {
                    t.openItem(id, 'View', false)
                }
            }
        },
    };
</script>

<style>
    /* .border-bottom-red { background-color: white; border-bottom: 2px solid var(--v-primary-base) !important; }
    .bottom { position: fixed; bottom: 30px; } */
</style>
